import React from "react";

const MyCycleAppPrivacy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>

      <div className="privacy-policy-content">
        <p>
          Welcome to MyCycle App! This Privacy Policy explains how we collect,
          use, disclose, and safeguard your information when you use our mobile
          application.
        </p>

        <h2>Information We Collect</h2>

        <p>We do not collect any of your information.</p>

        <h2>Sharing Your Information</h2>

        <p>
          We do not sell, trade, or otherwise transfer your personal information
          to outside parties. Your data is stored securely and is only accessed
          for the purposes mentioned in this Privacy Policy.
        </p>

        <h2>Security</h2>

        <p>
          We take reasonable measures to help protect your personal information
          from unauthorized access, use, or disclosure.
        </p>

        <h2>Changes to This Privacy Policy</h2>

        <p>
          We may update our Privacy Policy from time to time. We will notify you
          of any changes by posting the new Privacy Policy on this page.
        </p>

        <h2>Contact Us</h2>

        <p>
          If you have any questions or suggestions about our Privacy Policy,
          please contact us at abdelazizyacer@gmail.com.
        </p>
      </div>
    </div>
  );
};

export default MyCycleAppPrivacy;
